import React from 'react';
import './IOSApp.scss';

const DEVICE_PREVIEWS = [
  {
    key: 'web',
    title: 'Web',
    caption: 'Start here: search by sound, follow similarity, build crates, and learn what SB-VIBE hears across the catalog.',
    src: '/assets/dig-discover-preview.jpg',
    alt: 'Discover web app preview',
    fallback: '/assets/rooftop.png'
  },
  {
    key: 'ios',
    title: 'iOS',
    caption: 'Take the dig session with you for track previews, crate saves, and the road to CarPlay.',
    src: '/assets/crate.jpg',
    alt: 'iOS preview',
    fallback: '/assets/turntable.webp'
  },
  {
    key: 'macos',
    title: 'macOS',
    caption: 'Go deeper with DJ-library context, Serato and Rekordbox integrations, and real-time recommendations.',
    src: '/assets/dig-macos-preview.jpg',
    alt: 'macOS preview',
    fallback: '/assets/theshop.png'
  }
];

const IOSApp = () => {
  return (
    <section className="ios-page">
      <div className="ios-hero">
        <p className="eyebrow">Spinnin' Beans DIG</p>
        <h1>Digital Crate Digging on Every Device</h1>
        <p className="summary">
          DIG starts on the web and gets sharper on the devices serious listeners
          already use: mobile discovery, desktop prep, and DJ workflows powered by
          SB-VIBE.
        </p>
        <a className="dig-cta" href="https://dig.spinninbeans.com">
          Start Digging
        </a>
      </div>

      <div className="ios-grid">
        {DEVICE_PREVIEWS.map((shot) => (
          <article
            className={`shot-card ${shot.key}-card`}
            key={shot.key}
            tabIndex={0}
          >
            <div className={`preview-stage ${shot.key}-stage`}>
              <div
                className={`device-frame shared-device-frame ${shot.key}-frame`}
                data-orientation-behavior={
                  shot.key === 'ios' ? 'rotate-preview-inside-frame' : undefined
                }
              >
                <img
                  src={shot.src}
                  alt={shot.alt}
                  loading="lazy"
                  onError={(event) => {
                    event.currentTarget.onerror = null;
                    event.currentTarget.src = shot.fallback;
                  }}
                />
              </div>
            </div>
            <h2>{shot.title}</h2>
            <p>{shot.caption}</p>
          </article>
        ))}
      </div>

    </section>
  );
};

export default IOSApp;
